"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = void 0;
var _mui = require("@ori-ui/mui");
const StyledInput = exports.StyledInput = (0, _mui.styled)(_mui.TextField)(() => ({
  marginBottom: 0
}));
